import { render, staticRenderFns } from "./DashboardFidStats.vue?vue&type=template&id=3a46302d&"
import script from "./DashboardFidStats.vue?vue&type=script&lang=js&"
export * from "./DashboardFidStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports